import styled from 'styled-components';
export const FilesTitle = styled.h3`
  display: block;
  text-align: center;
  color: #023e8a;
  margin-top: 2rem;
`;
export const ImagesContainer = styled.div`
  width: auto;
  margin: 3rem 0;
  display: flex;
  justify-content: center;
   gap: 40px;
`;
export const ImageText = styled.a`
  text-decoration: underline;
  color: #126bdc;
  display: block;
  text-align: center;
  font-size: 18px;
  margin-top: 0.5rem;
`;
